import Skeleton from '@mui/material/Skeleton';
import styles from './Pagination.module.scss';
import { paginationIds } from '../../../../lib/tests/testIds';

const PaginationSkeleton = () => {
  return <Skeleton data-testid={paginationIds.paginationSkeleton} className={styles.paginationSkeleton} />;
};

export default PaginationSkeleton;
